export default "__VITE_ASSET__CE$JaQ7t__"